import { useParams, useNavigate } from "react-router-dom";
import TaskDetailView from "@/components/TaskDetailView";
import { ArrowLeft } from "lucide-react";

export default function TaskDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  return (
    <div className="space-y-4 max-w-3xl mx-auto" data-testid="task-detail-page">
      <button onClick={() => nav("/ukoly")} className="flex items-center gap-2 text-muted-foreground hover:text-foreground text-sm"><ArrowLeft size={16} /> Zpět na úkoly</button>
      <TaskDetailView id={id} onClose={() => nav("/ukoly")} />
    </div>
  );
}
